
    
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MessageLink"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Message"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subject"},"arguments":[],"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MessageBasicFields"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MessageBoard"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MessageConversation"},"directives":[]}]}}]};
  

    
  var names = {};
  function unique(defs) {
    return defs.filter(function (def) {
      if (def.kind !== 'FragmentDefinition') return true;
      var name = def.name.value;
      if (names[name]) {
        return false;
      } else {
        names[name] = true;
        return true;
      }
    });
  };

  doc.definitions = doc.definitions.concat(unique(require("../MessageBoard.fragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../MessageConversation.fragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("@aurora/shared-client/components/messages/MessageBasicFields.fragment.graphql").definitions));


    module.exports = doc
  
